import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import { addMinutes } from "date-fns";
import styles from "./styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actions from "../../actions";
import {
  getCancelVideoCallSuccess,
  getCompleteOffPlatformSuccess,
  getCompletingOffPlatform,
  getOffPlatformVideoBillableTimeId,
  getOffPlatformVideoSessionNoteId,
} from "../../selectors";
import CancelSessionDialog from "../WeeklyCalendarSessions/CancelSessionDialog";
import LoadingButton from "@mui/lab/LoadingButton";
import { ANTimePicker, ANDatePicker } from "@answersnow/pkg-theme";
import {
  getCancellationReasonLabel,
  getKeyCancellationReason,
} from "../../constants/cancelReasons";
import { Button, IconButton, Stack } from "@mui/material";
import { X } from "@phosphor-icons/react";
import { useGlobalToast } from "../../components/GlobalToastProvider";
import useGetCancellationReasons from "hooks/api/appointments/useGetCancellationReasons";
const mapStateToProps = (state) => ({
  cancelVideoCallSuccess: getCancelVideoCallSuccess(state),
  completingOffPlatform: getCompletingOffPlatform(state),
  completeOffPlatformSuccess: getCompleteOffPlatformSuccess(state),
  offPlatformVideoSessionNoteId: getOffPlatformVideoSessionNoteId(state),
  offPlatformVideoBillableTimeId: getOffPlatformVideoBillableTimeId(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      markClientNoShow: actions.markClientNoShow,
      cancelVideoCall: actions.cancelVideoCall,
      completeOffPlatformCall: actions.completeOffPlatformCall,
      getIncompleteOffPlatform: actions.getClinicianIncompleteOffPlatformCalls,
    },
    dispatch
  );

const StyledInput = withStyles({
  root: {
    // "& label.Mui-focused": {
    //     color: "#545A72",
    // },
    "& .MuiOutlinedInput-root": {
      minHeight: 41,
      "& fieldset": {
        borderRadius: 3,
        color: "#15171D",
        border: "1px solid #E1E3E9",
      },
      backgroundColor: "#F0F1F4",
      fontSize: 14,
      fontWeight: 500,
      "&:hover fieldset": {
        border: "1px solid #C8CAD2",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #C8CAD2",
      },
    },
    "& .MuiInput-root": {
      minHeight: 41,
      "& input": {
        color: "#1DA0D8",
        paddingBottom: 3,
      },
      backgroundColor: "#ffffff",
      fontSize: 17,
      fontWeight: 500,
      "&:hover fieldset": {
        border: "1px solid #fefefe",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #fefefe",
      },
      "&:hover": {
        backgroundColor: "#fefefe",
        "&:before": {
          borderBottom: "none",
        },
        "&:after": {
          borderBottom: "none",
        },
      },
      "&:before": {
        borderBottom: "none",
      },
      "&:after": {
        borderBottom: "none",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: 15,
    },
    "& .MuiFormHelperText-root": {
      backgroundColor: "#fafafa",
      margin: 0,
      padding: "0 5px",
      color: "red",
    },
  },
})(TextField);

export const CustomInput = React.forwardRef(function CustomInput(props, ref) {
  const { variant } = props;
  return <StyledInput ref={ref} variant={variant ? variant : "outlined"} size="small" {...props} />;
});

class CompleteOffPlatformDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      callDetails: {},
      offPlatformResult: true,
      startDate: null,
      endDate: null,
      offPlatformDetailsOpen: true,
      cancelSessionOpen: false,
      cancelSessionDetails: {},
      cancelReasonText: "",
      cancellationReasonId: "",
      responsibleForCancellation: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({
      callDetails: this.props.callDetails,
      startDate: this.props.callDetails?.scheduled_date,
      endDate: addMinutes(
        new Date(this.props.callDetails?.scheduled_date),
        this.props.callDetails?.call_duration
      ),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.completingOffPlatform && !this.props.completingOffPlatform) {
      this.setState({ loading: false });
      if (this.props.completeOffPlatformSuccess) {
        this.props.onToggleCompleteOffPlatformDialog(null);
        if (this.state.offPlatformResult === true) {
          this.props.openCptCodeDialog(
            {
              ...this.state.callDetails,
              start_date: this.state.startDate,
              end_date: this.state.endDate,
              sessionNoteId: this.props.offPlatformVideoSessionNoteId,
              billableTimeId: this.props.offPlatformVideoBillableTimeId,
            },
            true
          );
        }
      } else {
        this.props.showToast({
          message: "An error has occurred. Please try again",
          errorState: true,
        });
      }
    }
  }

  onChange = (name) => (e) => {
    const { value } = e.target;
    this.setState({ [name]: value });
  };

  handleDateChange = (val, name) => {
    let timeError = false;
    if (name === "startDate") {
      if (new Date(this.state.endDate) <= new Date(val)) {
        timeError = true;
      }
      this.setState({ [name]: val, timeError });
    } else {
      if (new Date(val) <= new Date(this.state.startDate)) {
        timeError = true;
      }
      this.setState({ [name]: val, timeError });
    }
  };

  onRadioButtonChange = (name) => (e) => {
    const { value } = e.target;
    this.setState({ [name]: this.stringToBoolean(value) });
  };

  stringToBoolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
    }
    return value;
  };

  onChangeCancelReason = (e) => {
    const cancellationReason = (this.props.cancellationReasons || []).find(
      (reason) => String(reason.id) === String(e.target.value)
    );
    if (cancellationReason) {
      this.setState({
        cancellationReasonId: cancellationReason.id,
        cancelReasonText: cancellationReason.displayLabel,
        responsibleForCancellation: cancellationReason.responsibleForCancellation,
      });
      return;
    }

    this.setState({ cancellationReasonId: "", cancelReasonText: e.target.value });
  };

  onChangeResponsibleForCancellation = (e) => {
    if (
      Array.isArray(this.props.cancellationReasons) &&
      this.props.cancellationReasons.length > 0
    ) {
      this.setState({
        cancellationReasonId: "",
        responsibleForCancellation: e.target.value,
        cancelReasonText: "",
      });
      return;
    }

    let cancelReasonText = getCancellationReasonLabel(e.target.value);
    this.setState({
      responsibleForCancellation: e.target.value,
      cancelReasonText,
      cancellationReasonId: "",
    });
  };

  onSubmit = () => {
    const { offPlatformResult, startDate, endDate, callDetails } = this.state;
    this.setState({ loading: true });
    if (offPlatformResult === true) {
      this.props.completeOffPlatformCall({
        startDate,
        endDate,
        id: callDetails.id,
      });
    } else if (offPlatformResult === "no-show") {
      this.props.markClientNoShow(callDetails.id);
    } else {
      this.setState({
        cancelSessionDetails: {
          ...callDetails,
          client_name: `${callDetails?.child_first_name} ${callDetails?.child_last_name}`,
        },
        cancelSessionOpen: true,
        cancelReasonText: "",
        cancellationReasonId: "",
        responsibleForCancellation: "",
        offPlatformDetailsOpen: false,
      });
    }
  };

  submitCancelSession = () => {
    const {
      cancelSessionDetails,
      cancelReasonText,
      cancellationReasonId,
      responsibleForCancellation,
    } = this.state;
    const selectedCatalogReason = (this.props.cancellationReasons || []).find(
      (reason) => String(reason.id) === String(cancellationReasonId)
    );
    const selectedCatalogReasonId = selectedCatalogReason?.id;
    let params = {
      message: cancelReasonText,
      responsibleForCancellation: getKeyCancellationReason(responsibleForCancellation),
      ...(selectedCatalogReasonId !== undefined
        ? { cancellationReasonId: selectedCatalogReasonId }
        : {}),
      id: cancelSessionDetails.id,
      clinicianUserId: cancelSessionDetails.clinician_user_id,
      clientId: cancelSessionDetails.client_id,
      cancelAllInstances: false,
    };
    this.props.cancelVideoCall(params);
    this.onToggleCancelSession();
  };

  onToggleCancelSession = () => {
    this.setState(
      {
        cancelSessionOpen: !this.state.cancelSessionOpen,
      },
      () => {
        if (!this.state.cancelSessionOpen) {
          this.setState({
            cancelReasonText: "",
            cancellationReasonId: "",
            cancelAllInstances: false,
            responsibleForCancellation: "",
            cancelSessionDetails: {},
          });
        }
      }
    );
  };

  buttonDisabled = () => {
    const { cancelReasonText, offPlatformResult } = this.state;
    if (offPlatformResult === "cancelled" && !cancelReasonText) {
      return true;
    }
    return false;
  };

  render() {
    const { offPlatformResult, startDate, endDate, offPlatformDetailsOpen, timeError, loading } =
      this.state;
    const { classes, onToggleCompleteOffPlatformDialog } = this.props;

    return (
      <>
        <Dialog
          maxWidth="xs"
          open={offPlatformDetailsOpen}
          onClose={() => onToggleCompleteOffPlatformDialog(null)}
          PaperProps={{
            style: {
              height: "fit-content",
              overflow: "visible",
            },
          }}
        >
          <DialogTitle>
            Confirm off-platform appointment
            <IconButton aria-label="close" onClick={() => onToggleCompleteOffPlatformDialog(null)}>
              <X />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers className={classes.dialogContent}>
            <Stack gap={9}>
              <FormControl>
                <FormLabel
                  component="legend"
                  style={{
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#545A72",
                    lineHeight: 1.4,
                  }}
                >
                  Did the appointment take place?
                </FormLabel>

                <RadioGroup
                  aria-label="offPlatformResult"
                  name="offPlatformResult"
                  value={offPlatformResult}
                  onChange={this.onRadioButtonChange("offPlatformResult")}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" size="small" />}
                    label={<Typography>Yes the appointment took place</Typography>}
                  />
                  <FormControlLabel
                    value={"cancelled"}
                    control={<Radio color="primary" size="small" />}
                    label={<Typography>No the appointment didn&apos;t take place</Typography>}
                  />
                  <FormControlLabel
                    value={"no-show"}
                    control={<Radio color="primary" size="small" />}
                    label={<Typography>No, the client should be marked as a no-show</Typography>}
                  />
                </RadioGroup>
              </FormControl>
              {offPlatformResult === true && (
                <>
                  <Grid item xs={12} sm={12}>
                    <FormControl margin="none" fullWidth>
                      <FormLabel
                        component="legend"
                        style={{
                          fontSize: 12,
                          fontWeight: 500,
                        }}
                      >
                        Date of appointment
                      </FormLabel>

                      <ANDatePicker
                        id="offplatformDatePicker"
                        value={startDate ? new Date(startDate) : null}
                        onChange={(date) => this.handleDateChange(date, "startDate")}
                        disableFuture
                        format="P" //"MM/dd/yyyy"
                      />
                    </FormControl>
                  </Grid>
                  <Stack direction="row" gap={5}>
                    <ANTimePicker
                      id="start-time"
                      label="Start time"
                      value={startDate ? new Date(startDate) : null}
                      onChange={(date) => this.handleDateChange(date, "startDate")}
                      minDate={new Date(startDate)}
                      variant="outlined"
                      color="primary"
                    />
                    <ANTimePicker
                      id="end-time"
                      label="End time"
                      value={endDate ? new Date(endDate) : null}
                      onChange={(date) => this.handleDateChange(date, "endDate")}
                      minDate={new Date(startDate)}
                      variant="outlined"
                      color="primary"
                    />
                  </Stack>
                </>
              )}

              {timeError && (
                <Grid item xs={12}>
                  <Typography component="p" style={{ fontSize: 15, color: "#DC2626" }}>
                    End Time cannot be before Start Time
                  </Typography>
                </Grid>
              )}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onToggleCompleteOffPlatformDialog(null)} color="secondary">
              Cancel
            </Button>
            <LoadingButton color="primary" onClick={this.onSubmit} loading={loading}>
              {offPlatformResult === true
                ? "Confirm and add session note"
                : offPlatformResult == "cancelled"
                  ? "Next"
                  : "Confirm"}
            </LoadingButton>
          </DialogActions>
        </Dialog>
        <CancelSessionDialog
          sessionDetails={this.state.cancelSessionDetails}
          open={this.state.cancelSessionOpen}
          cancelReasonText={this.state.cancelReasonText}
          cancellationReasonId={this.state.cancellationReasonId}
          responsibleForCancellation={this.state.responsibleForCancellation}
          closeDialog={this.onToggleCancelSession}
          onChangeCancelReason={this.onChangeCancelReason}
          onChangeResponsibleForCancellation={this.onChangeResponsibleForCancellation}
          submitCancelSession={this.submitCancelSession}
          cancellationReasons={this.props.cancellationReasons}
          cancellationReasonsLoading={this.props.cancellationReasonsLoading}
        />
      </>
    );
  }
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(function CompleteOffPlatformDialogWithToast(props) {
    const { showToast } = useGlobalToast();
    const {
      cancellationReasons,
      isLoading: cancellationReasonsLoading,
    } = useGetCancellationReasons();
    return (
      <CompleteOffPlatformDialog
        {...props}
        cancellationReasons={cancellationReasons}
        cancellationReasonsLoading={cancellationReasonsLoading}
        showToast={showToast}
      />
    );
  })
);
